<template>
  <el-form ref="guardForm" :model="guardForm" :rules="guardRules" label-width="110px">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="设备型号" prop="deviceModel">
          <el-input
            v-if="!isDetail()"
            v-model="guardForm.deviceModel"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ guardForm.deviceModel || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="出厂编号" prop="factoryNo">
          <el-input
            v-if="!isDetail()"
            v-model="guardForm.factoryNo"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ guardForm.factoryNo || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="设备状态" prop="status">
          <el-select v-if="!isDetail()" v-model="guardForm.status" style="width: 100%">
            <el-option
              v-for="item in typeList"
              :key="item.type"
              :label="item.typeName"
              :value="item.type"
            ></el-option>
          </el-select>
          <span v-else>{{ typeObj[guardForm.status] || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Object
    }
  },
  data() {
    return {
      typeList: [
        { type: 0, typeName: '启用' },
        { type: 1, typeName: '停用' }
      ],
      typeObj: {
        0: '启用',
        1: '停用'
      },
      guardForm: {}
    };
  },
  inject: ['isDetail'],

  watch: {
    value: {
      immediate: true,
      deep: true,
      handler: function (newVal) {
        this.guardForm = newVal;
      }
    },
    guardForm: {
      immediate: true,
      deep: true,
      handler: function (newVal) {
        this.$emit('change', newVal);
      }
    }
  },
  computed: {
    guardRules() {
      return {
        status: [{ required: !this.isDetail(), message: '请选择设备状态', trigger: 'change' }]
      };
    }
  },
  methods: {
    getNationNo() {
      // getNationNum().then(res => {
      //   if (!res.success) {
      //     return;
      //   }
      //   this.guardForm.mnNum = res.data
      // });
    },
    getData() {
      let data = {
        deviceModel: this.guardForm.deviceModel,
        factoryNo: this.guardForm.factoryNo,
        status: this.guardForm.status
      };
      return data;
    },
    setData(data) {
      const { deviceModel, factoryNo, status } = data;
      this.guardForm.deviceModel = deviceModel;
      this.guardForm.factoryNo = factoryNo;
      this.guardForm.status = status;
    },
    reset() {
      this.$refs.guardForm.resetFields();
    },
    validate() {
      let type;
      this.$refs.guardForm.validate(validated => {
        type = validated;
      });
      return type;
    }
  }
};
</script>
